document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('.site-content');
    if (!container || !container.children.length) return;

    var GROUP_STAGGER_MS = 100;
    var ITEM_STAGGER_MS = 60;

    function isVisible(el) {
        return getComputedStyle(el).position !== 'fixed';
    }

    // A grid/flex box whose visible children all share the same tag is
    // treated as a repeating list (post-feed, card grid, etc) and gets
    // its items revealed one by one instead of as a single block.
    function findRepeatingContainers(root) {
        var found = [];
        var all = root.querySelectorAll('*');
        for (var i = 0; i < all.length; i++) {
            var display = getComputedStyle(all[i]).display;
            if (display !== 'grid' && display !== 'flex') continue;

            var kids = Array.prototype.filter.call(all[i].children, isVisible);
            if (kids.length < 3) continue;

            var tag = kids[0].tagName;
            var repeating = kids.every(function (kid) { return kid.tagName === tag; });
            if (repeating) found.push(kids);
        }
        return found;
    }

    // Items are observed individually so each one reveals only when it
    // actually scrolls into view, not the instant its distant ancestor does.
    // Items that enter together in the same batch still stagger against
    // each other, in document order.
    var itemObserver = new IntersectionObserver(function (entries, obs) {
        var revealed = entries.filter(function (entry) { return entry.isIntersecting; });
        revealed.sort(function (a, b) {
            var position = a.target.compareDocumentPosition(b.target);
            return position & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
        });
        revealed.forEach(function (entry, index) {
            entry.target.style.transitionDelay = (index * ITEM_STAGGER_MS) + 'ms';
            obs.unobserve(entry.target);
        });
        requestAnimationFrame(function () {
            revealed.forEach(function (entry) { entry.target.classList.add('in-view'); });
        });
    }, { threshold: 0 });

    function revealGroup(group) {
        var repeats = findRepeatingContainers(group);

        if (repeats.length) {
            // The group is just a host for the staggered items below - reveal
            // it instantly so its own fade doesn't mask the item-by-item one.
            group.style.transition = 'none';
            group.style.opacity = '1';
            group.style.transform = 'none';

            repeats.forEach(function (items) {
                items.forEach(function (item) {
                    // Hide instantly (no transition) even while still off-screen,
                    // so there's neither a flash of full visibility nor an
                    // animated fade-out before it scrolls into view.
                    item.style.transition = 'none';
                    item.classList.add('stagger-item');
                    item.offsetHeight; // flush the transition:none before restoring it
                    item.style.transition = '';
                    itemObserver.observe(item);
                });
            });
        } else {
            group.classList.add('in-view');
        }
    }

    var groups = Array.prototype.filter.call(container.children, isVisible);
    if (!groups.length) return;

    var groupObserver = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                var index = groups.indexOf(entry.target);
                entry.target.style.transitionDelay = (index * GROUP_STAGGER_MS) + 'ms';
                revealGroup(entry.target);
                obs.unobserve(entry.target);
            }
        });
    }, { threshold: 0 });

    groups.forEach(function (group) { groupObserver.observe(group); });
});
